/**
 * Filtra el valor según restricción de entrada.
 * @param {string} value
 * @param {'text'|'varchar'|'number'|'decimal'|'alphanumeric'|null|undefined} restrict
 */
export const filterInputValue = (value, restrict) => {
  if (!restrict || value == null) return value;

  switch (restrict) {
    case 'number':
      return String(value).replace(/\D/g, '');
    case 'decimal':
      return String(value)
        .replace(/[^\d.]/g, '')
        .replace(/(\..*)\./g, '$1');
    case 'text':
    case 'varchar':
      return String(value).replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, '');
    case 'alphanumeric':
      return String(value).replace(/[^a-zA-Z0-9]/g, '');
    default:
      return value;
  }
};

export const buildSyntheticChangeEvent = (name, value) => ({
  target: { name, value },
  currentTarget: { name, value },
});
